TrelloModel = require 'models/internal/trello-model'

module.exports = class Plugin extends TrelloModel
  typeName: 'Plugin'



// WEBPACK FOOTER //
// ./app/scripts/models/plugin.coffee